export default __webpack_public_path__ + "static/media/pixala clikd(1).55c875fb.png";